/* ══════════════════════════════════════════════════════════════════
   Ordetect — interactivité portée du site source (Next.js → Shopify).
   Chaque brique est isolée : une exception n'éteint pas les suivantes
   (règle du skill). Vérifier la console pour un ReferenceError avant
   de conclure qu'un comportement ne marche pas.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  document.documentElement.classList.add("ordetect-js");

  var briques = {

    /* Bandeau d'offre de lancement, en haut de toutes les pages.
       Fin annoncée : 12 octobre 2026 — au-delà de cette date le bandeau
       disparaît tout seul (une réduction sans fin est un prix trompeur).
       Fermeture mémorisée par visiteur (localStorage, qui peut échouer en
       navigation privée : d'où le try/catch). */
    barrePromo: function () {
      var FIN = new Date("2026-10-12T23:59:59+02:00");
      if (new Date() > FIN) return;
      if (document.getElementById("ordetect-promo")) return;
      try { if (localStorage.getItem("ordetect-promo-ferme") === "1") return; } catch (e) {}

      var bar = document.createElement("div");
      bar.id = "ordetect-promo";
      bar.innerHTML =
        '<a href="/collections/detection">' +
        '<strong>Offre de lancement</strong> — jusqu’à <strong>‑20 %</strong> sur les détecteurs' +
        '<span class="sep" aria-hidden="true">·</span>Livraison offerte' +
        '<span class="sep" aria-hidden="true">·</span>jusqu’au 12 octobre</a>' +
        '<button type="button" aria-label="Fermer">×</button>';

      var css = document.createElement("style");
      css.textContent =
        "#ordetect-promo{position:relative;z-index:60;background:var(--c-ink,#1D1D1F);color:#fff;font-size:.78rem;line-height:1.35;padding:.55rem 2.2rem .55rem 1rem;text-align:center}" +
        "#ordetect-promo a{color:inherit;text-decoration:none;display:inline-block}" +
        "#ordetect-promo strong{font-weight:600;color:var(--c-gold,#C9A227)}" +
        "#ordetect-promo .sep{margin:0 .45rem;opacity:.5}" +
        "#ordetect-promo button{position:absolute;right:.45rem;top:50%;transform:translateY(-50%);background:none;border:0;color:#fff;opacity:.65;font-size:1.1rem;line-height:1;padding:.25rem .45rem;cursor:pointer}" +
        "@media (max-width:640px){#ordetect-promo .sep+*,#ordetect-promo .sep{display:none}}";
      document.head.appendChild(css);

      bar.querySelector("button").addEventListener("click", function () {
        bar.remove();
        try { localStorage.setItem("ordetect-promo-ferme", "1"); } catch (e) {}
      });
      document.body.insertBefore(bar, document.body.firstChild);
    },

    /* Révélation au défilement — IntersectionObserver + repli.
       Le contenu est déjà visible (ordetect-overrides.css) ; ceci ne fait
       qu'ajouter l'animation quand elle peut jouer. */
    reveal: function () {
      var els = document.querySelectorAll('.reveal[data-reveal="out"]');
      if (!els.length) return;
      if (!("IntersectionObserver" in window)) {
        els.forEach(function (el) { el.setAttribute("data-reveal", "in"); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.setAttribute("data-reveal", "in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      els.forEach(function (el) { io.observe(el); });
      // Filet : tout révéler après 1,2 s quoi qu'il arrive.
      setTimeout(function () { els.forEach(function (el) { el.setAttribute("data-reveal", "in"); }); }, 1200);
    },

    /* En-tête : fond opaque au défilement (scrollY > 16). */
    headerScroll: function () {
      var header = document.querySelector("header.sticky");
      if (!header) return;
      var sync = function () { header.setAttribute("data-scrolled", window.scrollY > 16 ? "true" : "false"); };
      sync();
      window.addEventListener("scroll", sync, { passive: true });
    },

    /* Menu mobile plein écran. */
    menuMobile: function () {
      var btn = document.querySelector('[aria-controls="menu-mobile"]');
      var panel = document.getElementById("menu-mobile");
      if (!btn || !panel) return;
      var set = function (open) {
        panel.setAttribute("data-open", open ? "true" : "false");
        panel.setAttribute("aria-hidden", open ? "false" : "true");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
        document.body.style.overflow = open ? "hidden" : "";
        panel.querySelectorAll("a").forEach(function (a) { a.tabIndex = open ? 0 : -1; });
      };
      btn.addEventListener("click", function () {
        set(panel.getAttribute("data-open") !== "true");
      });
      panel.addEventListener("click", function (e) { if (e.target.closest("a")) set(false); });
      window.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
    },

    /* Ancres /#x et #x — défilement doux avec compensation d'en-tête collé. */
    anchors: function () {
      document.addEventListener("click", function (e) {
        var a = e.target.closest('a[href*="#"]');
        if (!a) return;
        var url = a.getAttribute("href");
        var hash = url.indexOf("#") > -1 ? url.slice(url.indexOf("#")) : "";
        if (!hash || hash === "#") return;
        var samePage = url === hash || url === "/" + hash || url.replace(/^\//, "") === location.pathname.replace(/^\//, "") + hash;
        var target = document.querySelector(hash);
        if (!target || (!samePage && url.indexOf(location.pathname) === -1 && url[0] !== "#" && !url.startsWith("/#"))) return;
        e.preventDefault();
        var header = document.querySelector("header.sticky");
        var offset = (header ? header.offsetHeight : 0) + 12;
        var y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
        // Filet : si smooth est ignoré, on force après 400 ms.
        setTimeout(function () { if (Math.abs(window.scrollY - y) > 4) window.scrollTo(0, y); }, 400);
        history.replaceState(null, "", hash);
      });
    },

    /* Filtres de catégorie du blog (data-filter sur les boutons, data-cat sur les <li>). */
    blogFilters: function () {
      var btns = document.querySelectorAll("[data-filter]");
      if (!btns.length) return;
      var cards = document.querySelectorAll("li[data-cat]");
      var apply = function (cat) {
        cards.forEach(function (c) { c.hidden = !(cat === "*" || c.getAttribute("data-cat") === cat); });
        btns.forEach(function (b) {
          var on = b.getAttribute("data-filter") === cat;
          b.setAttribute("aria-pressed", on ? "true" : "false");
          b.classList.toggle("border-ink", on);
          b.classList.toggle("bg-ink", on);
          b.classList.toggle("text-bg", on);
          b.classList.toggle("border-line", !on);
          b.classList.toggle("bg-surface", !on);
          b.classList.toggle("text-muted", !on);
        });
      };
      btns.forEach(function (b) {
        b.addEventListener("click", function () { apply(b.getAttribute("data-filter")); });
      });
    },

    /* Panier : ajout AJAX + tiroir + « Acheter maintenant » → checkout direct. */
    cart: function () {
      var drawer = document.getElementById("ordetect-cart-drawer");
      var openDrawer = function () {
        if (drawer) { drawer.setAttribute("data-open", "true"); document.body.style.overflow = "hidden"; refresh(); }
      };
      var closeDrawer = function () {
        if (drawer) { drawer.setAttribute("data-open", "false"); document.body.style.overflow = ""; }
      };
      document.addEventListener("click", function (e) {
        if (e.target.closest("[data-cart-open]")) { e.preventDefault(); openDrawer(); }
        if (e.target.closest("[data-cart-close]") || e.target.classList.contains("cart-drawer__overlay")) closeDrawer();
      });
      window.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

      function setCount(n) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = n; });
      }
      function refresh() {
        fetch("/?sections=ordetect-cart-drawer").then(function (r) { return r.json(); }).then(function (j) {
          var html = j["ordetect-cart-drawer"];
          if (html && drawer) {
            var tmp = document.createElement("div"); tmp.innerHTML = html;
            var fresh = tmp.querySelector(".cart-drawer__panel");
            var cur = drawer.querySelector(".cart-drawer__panel");
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          }
        }).catch(function () {});
        fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
      }

      // Formulaires produit : intercepter pour rester sur la page (tiroir).
      document.addEventListener("submit", function (e) {
        var form = e.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var buyNow = form.dataset.buyNow === "1" || (document.activeElement && document.activeElement.hasAttribute("data-buy-now"));
        form.dataset.buyNow = "";
        if (btn) btn.setAttribute("aria-busy", "true");
        fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (buyNow) { window.location.href = "/checkout"; return; }
            refresh(); openDrawer();
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.removeAttribute("aria-busy"); });
      });

      // Modifs de quantité dans le tiroir.
      document.addEventListener("click", function (e) {
        var b = e.target.closest("[data-line-change]");
        if (!b) return;
        e.preventDefault();
        fetch("/cart/change.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.lineChange })
        }).then(function () { refresh(); }).catch(function () {});
      });

      refresh();
    },

    /* Barre d'achat collée (mobile) : barre propre construite en JS, révélée
       quand le bouton « Ajouter au panier » principal a défilé hors champ.
       Le clic relaie vers ce bouton (déjà câblé pour l'ajout AJAX). */
    stickyBuy: function () {
      if (!document.getElementById("ordetect-buy") && !document.querySelector('main form[action="/cart/add"]')) return; // fiches produit (pack, pinpointer, gabarit générique)
      var mainCta = null;
      document.querySelectorAll("main button").forEach(function (b) {
        var t = (b.textContent || "").trim().toLowerCase();
        if (!mainCta && (t === "ajouter au panier" || (t.indexOf("panier") > -1 && t.indexOf("voir") === -1))) mainCta = b;
      });
      if (!mainCta) return;

      var ghost = document.querySelector('div.fixed.inset-x-0.bottom-0.md\\:hidden');
      if (ghost) ghost.style.display = "none";

      /* Prix lu au plus près du bouton (le 1er « € » de la page pouvait être un autre prix). */
      var price = "";
      for (var up = mainCta, k = 0; up && k < 5 && !price; k++) {
        up = up.parentElement;
        var m = up && (up.innerText || "").match(/\d[\d\s.,]*€/);
        if (m) price = m[0].trim();
      }
      if (!price) price = (document.body.innerText.match(/\d[\d\s.,]*€/) || [""])[0].trim();
      var bar = document.createElement("div");
      bar.id = "ordetect-stickybuy";
      bar.hidden = true;
      bar.innerHTML =
        '<span class="ordetect-stickybuy__price">' + price + '</span>' +
        '<button type="button" class="ordetect-stickybuy__btn">Ajouter au panier</button>';
      var css = document.createElement("style");
      css.textContent =
        '#ordetect-stickybuy{position:fixed;left:0;right:0;bottom:0;z-index:70;display:flex;' +
        'align-items:center;gap:1rem;background:#fff;border-top:1px solid var(--c-border,#D2D2D7);' +
        'padding:.7rem 1rem calc(.7rem + env(safe-area-inset-bottom));' +
        'box-shadow:0 -6px 24px rgba(0,0,0,.08);}' +
        '#ordetect-stickybuy[hidden]{display:none;}' +
        '@media(min-width:768px){#ordetect-stickybuy{display:none!important;}}' +
        '.ordetect-stickybuy__price{font-weight:600;color:var(--c-ink,#1D1D1F);white-space:nowrap;}' +
        '.ordetect-stickybuy__btn{margin-left:auto;flex-shrink:0;border:0;border-radius:999px;' +
        'background:var(--c-ink,#1D1D1F);color:#fff;font-size:.68rem;text-transform:uppercase;' +
        'letter-spacing:.14em;padding:.95rem 1.5rem;cursor:pointer;}';
      document.head.appendChild(css);
      document.body.appendChild(bar);
      bar.querySelector(".ordetect-stickybuy__btn").addEventListener("click", function () { mainCta.click(); });

      /* Barre visible dès l arrivée tant que le vrai bouton n est pas à l écran
         (avant : seulement après l avoir dépassé ; sur mobile le prix et le
         bouton étaient sous la ligne de flottaison à l arrivée de la pub). */
      var sync = function () { var r = mainCta.getBoundingClientRect(); bar.hidden = r.top < window.innerHeight && r.bottom > 0; };
      window.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync, { passive: true });
      sync();
    },

    /* Vidéos d'ambiance : ne charger le .mp4 que lorsque le bandeau approche
       du viewport (économie data mobile, ne pèse pas sur le LCP). */

    /* Galerie produit (fiches pack et pinpointer) : le balisage porté du site
       Next.js contient les miniatures, les flèches et le compteur, mais aucun
       script ne les reliait — les photos étaient donc figées. Ici : clic sur une
       miniature, flèches, balayage tactile, compteur et miniature active. */
    galerieProduit: function () {
      var prev = document.querySelector('main button[aria-label="Photo précédente"]');
      var next = document.querySelector('main button[aria-label="Photo suivante"]');
      var thumbs = [].slice.call(document.querySelectorAll('main button[aria-label^="Voir la photo"]'));
      if (!prev || thumbs.length < 2) return;
      var frame = prev.parentElement;
      var mainImg = frame.querySelector("img");
      if (!mainImg) return;
      var counter = frame.querySelector("span");
      var srcs = thumbs.map(function (b) { var im = b.querySelector("img"); return im ? im.getAttribute("src") : ""; });
      var i = 0;

      var big = function (src, w) { return src.replace(/_\d+x(\.[a-zA-Z]+)/, "_" + w + "x$1"); };

      var show = function (n) {
        var total = srcs.length;
        i = ((n % total) + total) % total;
        var s = srcs[i];
        if (!s) return;
        mainImg.setAttribute("src", big(s, 1200));
        mainImg.setAttribute("srcset", [600, 900, 1200].map(function (w) { return big(s, w) + " " + w + "w"; }).join(", "));
        if (counter) counter.textContent = (i + 1) + " / " + total;
        thumbs.forEach(function (b, k) {
          var on = k === i;
          b.setAttribute("aria-current", on ? "true" : "false");
          b.classList.toggle("ring-1", on);
          b.classList.toggle("ring-ink", on);
          b.classList.toggle("opacity-100", on);
          b.classList.toggle("opacity-55", !on);
        });
      };

      thumbs.forEach(function (b, k) { b.addEventListener("click", function () { show(k); }); });
      prev.addEventListener("click", function () { show(i - 1); });
      if (next) next.addEventListener("click", function () { show(i + 1); });

      /* Balayage tactile : sur mobile les flèches sont masquées (hidden md:flex). */
      var x0 = null;
      frame.addEventListener("touchstart", function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      frame.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      }, { passive: true });
    },

    /* Réassurance collée aux boutons d achat : livraison, délai et retour
       n apparaissaient qu à ~1 600 px plus bas sur mobile. Formule reprise
       mot pour mot du site (délais inchangés). */
    reassuranceAchat: function () {
      var buy = [].slice.call(document.querySelectorAll("main button")).filter(function (b) {
        return /acheter maintenant/i.test(b.textContent || "");
      })[0];
      if (!buy || document.getElementById("ordetect-reassurance")) return;
      var box = document.createElement("ul");
      box.id = "ordetect-reassurance";
      box.innerHTML =
        "<li><span aria-hidden=\"true\">✓</span> Livraison offerte, expédié de France</li>" +
        "<li><span aria-hidden=\"true\">✓</span> Livré en 2 à 5 jours ouvrés</li>" +
        "<li><span aria-hidden=\"true\">✓</span> Satisfait ou remboursé 30 jours · garantie 2 ans</li>";
      var css = document.createElement("style");
      css.textContent = "#ordetect-reassurance{list-style:none;margin:.9rem 0 0;padding:0;display:grid;gap:.35rem;font-size:.8rem;color:var(--c-ink,#1D1D1F)}#ordetect-reassurance span{color:var(--c-gold,#7F6637);font-weight:600;margin-right:.35rem}";
      document.head.appendChild(css);
      buy.insertAdjacentElement("afterend", box);

      /* Fiche Initiation : rappel juste sous le bouton de ce que le pack apporte en plus. */
      if (/\/products\/detecteur-de-metaux-essentiel/.test(location.pathname)) {
        var up = document.createElement("a");
        up.id = "ordetect-upsell";
        up.href = "/products/detecteur-de-metaux-ordetect";
        up.innerHTML = "<strong>Pour 60 € de plus, le pack complet à 199 €</strong>" +
          "<span>Détecte jusqu'à 25 cm au lieu de 16 · 7 modes qui identifient la cible avant de creuser · balance du sol · sacoche rigide</span>" +
          "<em>Voir le pack complet →</em>";
        var css2 = document.createElement("style");
        css2.textContent = "#ordetect-upsell{display:grid;gap:.25rem;margin:1rem 0 0;padding:.8rem 1rem;border:1px solid var(--c-gold,#7F6637);border-radius:.6rem;text-decoration:none;color:var(--c-ink,#1D1D1F);font-size:.8rem;line-height:1.4}#ordetect-upsell strong{font-size:.9rem}#ordetect-upsell em{font-style:normal;font-weight:600;color:var(--c-gold,#7F6637)}";
        document.head.appendChild(css2);
        box.insertAdjacentElement("afterend", up);
      }
    },

    lazyAmbiance: function () {
      var vids = [].slice.call(document.querySelectorAll("video[data-ambiance-src]"));
      if (!vids.length) return;
      var load = function (v) {
        if (v.dataset.ambianceLoaded) return;
        v.dataset.ambianceLoaded = "1";
        var s = document.createElement("source");
        s.src = v.getAttribute("data-ambiance-src");
        s.type = "video/mp4";
        v.appendChild(s);
        v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (!("IntersectionObserver" in window)) { vids.forEach(load); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: "400px 0px" });
      vids.forEach(function (v) { io.observe(v); });
      /* Repli : au premier défilement, charger tout ce qui reste. */
      var onScroll = function () {
        window.removeEventListener("scroll", onScroll);
        vids.forEach(function (v) { io.unobserve(v); load(v); });
      };
      window.addEventListener("scroll", onScroll, { passive: true, once: true });
    }
  };

  function run() {
    for (var nom in briques) {
      try { briques[nom](); } catch (err) { console.warn("[ordetect] " + nom, err); }
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
